// extracted by mini-css-extract-plugin
export default {"favoriteIcon":"ReorderFavoritesModal-module__favoriteIcon--ItAXC","animatedBackground":"ReorderFavoritesModal-module__animatedBackground--4x578"};